function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ReactShim from '@square/react-shim/components/react-shim';
import * as Page from '@squareup/banking-shared-ui/page';

// eslint-disable-next-line import/no-unassigned-import
import '@squareup/banking-shared-ui/css';
export default class PageShim extends ReactShim {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "library", () => Page);
  }
}